<template>
  <!--统计部分左侧机构可选择项与已选择项-->
  <div class="dept-left">
    <div>
      <el-input
        size="mini"
        placeholder="输入关键字进行过滤"
        v-model="filterText"
      >
      </el-input>
      <el-tree
        :expand-on-click-node="false"
        style="overflow:auto;"
        :style="{ height: (heightAll - 80) / 2 + 'px' }"
        :data="originalData"
        show-checkbox
        default-expand-all
        node-key="deptId"
        ref="tree"
        @check-change="singleNodeChange"
        :check-strictly="true"
        :filter-node-method="filterNode"
        highlight-current
        :props="defaultProps"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span :title="node.label">
            <span v-if="node.label.length < 17">
              {{ node.label }}
            </span>
            <span v-else>
              <el-tooltip
                class="item"
                effect="dark"
                :content="node.label"
                placement="top-start"
              >
                <span>{{ node.label.slice(0, 16) + "..." }}</span>
              </el-tooltip>
            </span>
          </span>
          <span v-show="data.childDeptList && data.childDeptList.length > 0">
            <el-button type="text" size="mini" @click="allChoose(node, data)">全选</el-button>
            <el-button type="text" size="mini" @click="cancelChoose(node, data)">取消全选</el-button>
          </span>
        </span>
      </el-tree>
    </div>
    <div class="dept_title">已选机构</div>
    <div :style="{ height: (heightAll - 80) / 2 + 'px', overflow: 'auto' }">
      <div class="dept_val" v-for="(label, index) in labelArr" :key="index">
        {{ index }}:{{ label }}&nbsp;
      </div>
    </div>
    <div class="ent_button" v-if="btnable">
      <el-button type="primary" class="btnDe" size="mini" @click="checkEntry">确定</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getDept } from "../../api/module/dept";
import { forData } from "../../utils/deptRemoveNull";

export default {
  name: "deptChoosed",
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    heightTree() {
      // console.log(this.he)
    }
  },
  computed: {
    ...mapState(["logInfo"])
  },
  data() {
    return {
      filterText: "", // 搜索字符
      labelArr: [], // 选中的节点label值
      checkId: [], // 选中的节点id值
      originalData: [], // 原始数据值
      defaultProps: {
        children: "childDeptList",
        label: "deptName"
      }
      // heightTree: this.$refs.tree.offsetHeight
    };
  },
  props: ["currentMenuId", "heightAll", "value", "btnable"],
  model: {
    prop: "value",
    event: "returnBack"
  },
  methods: {
    // 搜索
    filterNode(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    },
    childCheck(data, children, id, arr) {
      arr.push(data[id]);
      if (data[children] && data[children].length > 0) {
        let childData = data[children];
        childData.forEach(item => {
          this.childCheck(item, children, id, arr);
        });
      }
      return arr;
    },
    // 全选操作，调用childCheck 获取选中的节点和其下的所有子节点
    allChoose(node, data) {
      let arr = [];
      let resultCheckedArr = this.childCheck(
        data,
        "childDeptList",
        "deptId",
        arr
      );
      // 特殊情况 deptId = 0 的永远不可选
      let restArr = resultCheckedArr.filter(item => item != "0");
      restArr.forEach(item => {
        this.$refs.tree.getNode(item).checked = true;
      });
      this.getCheckedLabel();
    },
    // 取消全选
    cancelChoose(node, data) {
      let arr = [];
      let resultCheckedArr = this.childCheck(
        data,
        "childDeptList",
        "deptId",
        arr
      );
      resultCheckedArr.forEach(item => {
        this.$refs.tree.getNode(item).checked = false;
      });
      this.getCheckedLabel();
    },
    // 获取选中的label值
    getCheckedLabel() {
      let labelArr = [];
      let checkId = [];
      let allLabel = this.$refs.tree.getCheckedNodes();
      allLabel.forEach(label => {
        labelArr.push(label.deptName);
        checkId.push(label.deptId);
      });
      this.labelArr = labelArr;
      this.checkId = checkId;
      this.$emit("returnBack", this.checkId);
    },
    //单个节点变化时 获取选中的节点
    singleNodeChange() {
      this.getCheckedLabel();
    },
    // 确认选中了
    checkEntry() {
      // console.log(this.checkId);

      this.$emit("returnChecked", this.checkId);
    },
    // 获取初始时的数据
    initOriginData() {
      // console.log(this.currentMenuId)
      getDept(
        null,
        res => {
          // console.log("depttttt",res)
          let temp = JSON.parse(JSON.stringify(res.obj));
          let arr = [];
          arr.push(temp);
          this.originalData = arr;
          if (this.originalData[0].deptId === "0") {
            this.originalData[0].disabled = true;
          }
          forData(this.originalData);
        },
        () => {
          // console.log(error);
        },
        this.currentMenuId
      );
    },
    // 设置默认选中的deptId
    initDefaultedChecked() {
      let arr = [];
      // if(this.logInfo.deptId !== '0'){
      arr.push(this.logInfo.deptId);
      this.$refs.tree.setCheckedKeys(arr);
      this.labelArr.push(this.logInfo.deptName);
      this.checkId = arr;
      // }
    }
  },
  mounted() {
    this.initOriginData();
    this.initDefaultedChecked();
  },
  activated() {
    if (this.refreshDeptFlag) {
      this.initOriginData();
    }
  }
};
</script>

<style scoped>
.dept-left {
  width: 280px;
  position: relative;
  border: 1px solid #e9e9e9;
  border-right: none;
  padding: 5px;
  background: #f9f9f9;
}
.el-tree {
  background: transparent;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  padding-right: 8px;
  font-weight: bold;
}
.dept_title {
  text-align: center;
  background: #466389;
  color: #fff;
  font-size: 12px;
  margin: 10px auto;
  padding: 5px 0;
  /*border-radius: 5px;*/
}
.dept_val {
  font-size: 11px;
  padding: 5px;
}
.ent_button {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>
